import cx from 'classnames'
import Styles from './OnboardingLoader.module.scss'
import CompanyLogo from 'components/CompanyLogo/CompanyLogo'
import { WhiteLabelLogo } from 'components/WhiteLabelLogo/WhiteLabelLogo'
import { Spinner } from 'common/Spinner/Spinner'
import blazeHeroText from './blazeHeroText.png'
import { useEffect, useState } from 'react'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Workspace } from 'types'

interface OnboardingLoaderProps {
  fadeIn: boolean
  fadeOut: boolean
  workspace?: Workspace | null
}

const OnboardingLoader = ({ fadeIn, fadeOut, workspace }: OnboardingLoaderProps) => {
  const [showHero, setShowHero] = useState(false)
  const isWhitelabel = workspace?.is_whitelabel

  useEffect(() => {
    setTimeout(() => setShowHero(true), 2200)
  }, [])

  return (
    <div
      className={cx(Styles.container, {
        [Styles.fadeIn]: fadeIn,
        [Styles.fadeOut]: fadeOut,
      })}
    >
      <div className={Styles.textContainer}>
        <div className={Styles.logoAndCompanyName}>
          {isWhitelabel ? <WhiteLabelLogo workspace={workspace} /> : <CompanyLogo red />}
        </div>
        <div className={Styles.content}>
          <div className={Styles.headline}>
            {showHero && !isWhitelabel && (
              <img src={blazeHeroText} className={Styles.blazeHero} alt="The fastest AI content tool ever made." />
            )}
          </div>
          <div className={Styles.footer}>
            <div className={Styles.spinnerContainer}>
              <Spinner className={Styles.spinner} variant="dark" />
            </div>
            <div className={Styles.blink}>
              <Heading level={5} color="inherit">
                Preparing your workspace
              </Heading>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { OnboardingLoader }
